<script setup>
/******************************************************************************
 * PageComponent: MeterReading Errors
 *****************************************************************************/
import SvgIcon from "Components/SvgIcon/SvgIcon.vue";
defineProps({
    errors: {
        type: Array,
        required: true,
    },
});
</script>

<template>
    <section class="summary">
        <header>
            <h1>
                Um fortzufahren müssen die folgenden Vorraussetzungen erfüllt
                werden:
            </h1>
        </header>
        <ul>
            <li v-for="(error, index) in errors" :key="index">
                <svg-icon name="error" />
                <span
                    class="error-message"
                    v-html="error.replace(/\*(.*?)\*/g, '<strong>$1</strong>')"
                />
            </li>
        </ul>
    </section>
</template>

<style lang="scss" scoped>
.summary {
    padding: #{get($sizes, "base") * 0.5};
    border: get($sizes, "border") solid palette("state", "error");
    margin-top: #{get($sizes, "base") * 1};

    background-color: palette("state", "warning");
    color: color.adjust(palette("state", "error"), $lightness: -25%);
    border-radius: get($sizes, "radius");

    font-weight: 400;

    @include respond-to("medium") {
        margin-top: #{get($sizes, "base") * 2};
    }

    h1 {
        margin: 0 0 #{get($sizes, "base") * 1} 0;

        font-size: #{get($sizes, "base") * 1};
        font-weight: 500;
    }
}

ul {
    display: flex;
    flex-direction: column;

    padding: 0;
    margin: 0;
    gap: #{get($sizes, "base") * 0.5};

    list-style: none;
}

li {
    display: flex;

    gap: #{get($sizes, "base") * 0.5};

    &:not(:last-child) {
        padding-bottom: #{get($sizes, "base") * 0.5};
        border-bottom: get($sizes, "border") solid palette("state", "error");
    }
}
</style>

<style lang="scss">
.error-message > strong {
    color: color.adjust(palette("state", "error"), $lightness: -15%);

    font-weight: 500;
}
</style>
